import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {connectRefinementList} from 'react-instantsearch-dom';

import ChevronDown from './ChevronDown';

const RefinementsDropdown = ({items, currentRefinement, refine, facetLabel}) => {
  const [showFields, setShowFields] = useState(true);
  const activeRefinements = currentRefinement.length;
  const hasRefinements = currentRefinement.length > 0;

  let sortedItems = items;

  /**
   * Compare the label property of the array objects.
   * Sort alphabetically.
   */
  function compareLabel(a, b) {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  }
  /**
   * Compare the label property of the array objects.
   * Sort numerically.
   */
  function compareLabelFloat(a, b) {
    if (parseFloat(a.label) < parseFloat(b.label)) {
      return -1;
    }
    if (parseFloat(a.label) > parseFloat(b.label)) {
      return 1;
    }
    return 0;
  }

  if (facetLabel === 'Product Type' || facetLabel === 'Price') {
    const compareFunc = facetLabel === 'Product Type' ? compareLabel : compareLabelFloat;
    sortedItems = items.sort(compareFunc);
  }

  return (
    <div className="search-page__dropdown">
      <button
        className={`search-page__dropdown-trigger ${hasRefinements ? 'active' : ''}`}
        onClick={() => {
          setShowFields(!showFields);
        }}
      >
        <span>
          {facetLabel} {hasRefinements && `(${activeRefinements})`}
        </span>
        <ChevronDown style={!showFields ? {transform: 'rotate(180deg)'} : null} />
      </button>
      <div className="search-page__dropdown-fields" hidden={showFields}>
        {sortedItems.map(item => (
          <div
            className="search-page__dropdown-value"
            key={item.label}
            style={{fontWeight: item.isRefined ? 'bold' : ''}}
            onClick={event => {
              event.preventDefault();
              refine(item.value);
            }}
          >
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};

RefinementsDropdown.propTypes = {
  items: PropTypes.array,
  currentRefinement: PropTypes.array,
  refine: PropTypes.func,
  facetLabel: PropTypes.string,
};

const CustomRefinementList = connectRefinementList(RefinementsDropdown);

export default CustomRefinementList;
